import { ITask } from '../types/task.interface';

export function sortTasksByCompletedOnDate(tasks: ITask[]) {
  const now = +new Date();

  return [...tasks].sort((t1, t2) => +new Date(t2.completedOn ?? now) - +new Date(t1.completedOn ?? now));
}
